import { useMediaQuery } from "@mui/material";

export const useDesktopMediaQuery = () => {
  // '(min-width:600px)' : if device is 600px or greater
  // '(max-width:600px)' : if device is 600px or smaller
  // i.e. min-width: this is the minimum width that a certain design pertains to. if the width of the screen gets smaller than this min-width, then the design no longer pertains
  // i.e. max-width: this is the max width that the design pertains to. if the width gets larger than this max width, then the design no longer pertains
  const isDesktopScreenWidth = useMediaQuery('(min-width:900px)');
  // console.log(isDesktopScreenWidth)
  return isDesktopScreenWidth;
}
